import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IdynamicFormItem, IDynamicFormItemIcon } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { get } from 'lodash';

@Component({
  selector: 'ispm-recommendation-target-genetics',
  templateUrl: './recommendation-target-genetics.component.html',
  styleUrls: ['./recommendation-target-genetics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('RecommendationTargetGenetics')
export class RecommendationTargetGeneticsComponent implements OnInit, IWidgetItem {

  set widgetConfig(widgetConfig: IdynamicFormItem) {
    Object.assign(this, widgetConfig.widgetPayload);
  }

  set widgetData(widgetData: any) {
    this.data = widgetData;
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }

  item: IDynamicFormItemIcon = {
    name: 'Partial match',
    cssClass: 'tokenLabelOrange'
  };

  matchedItem: IDynamicFormItemIcon = {
    name: 'Matched',
    cssClass: 'tokenLabelGreen'
  };

  notReportedItem: IDynamicFormItemIcon = {
    name: 'Not reported',
    cssClass: 'tokenLabelRed'
  };

  conf = {
    'path': 'name',
    'type': 'text',
    'cssClasses': 'default-editable-value',
    'link': this.item
  };

  geneInfoConf = {
    'path': 'display',
    'type': 'text'
  };

  data: any;

  constructor(
    private _changeDetector: ChangeDetectorRef,
  ) { }

  ngOnInit() {
  }

  biomarkersArePartiallyMatched() {
    return !get(this.data, ['biomarkersFullyMatched'], true);
  }

  biomarkerIsMatched(biomarker: any) {
    return get(biomarker, ['isMatched'], true);
  }
}
